import { planBuilderMonthlyDiscountedPriceForQuantityPackSelector, planBuilderProductConfigurationsSelector } from '../../../selectors/PlanBuilderSelectors';
import { planBuilderMonthlyDiscountedPriceForProductSelector } from '../../../selectors/PlanBuilderSelectors';
import { createProductConfig } from 'pricing-pages-lib/utils/productConfigUtils';
import Raven from 'raven-js';
import { useAppSelector } from '../../../reducers';
import { isCoreSeatSkuSelector, isQuantifiableSeatProOrEntSkuSelector, skuIdHasBundledProductsSelector, skuIdIsHubSelector, skuIdIsQuantityPackSelector, skuSelector } from '../../../selectors/ProductsSelectors';
export const useShoppingCartPrice = ({
  productConfiguration
}) => {
  const popPrice = useAppSelector(state => {
    return planBuilderMonthlyDiscountedPriceForProductSelector(state, {
      productConfiguration
    });
  });
  const skuIdIsQuantityPack = useAppSelector(state => skuIdIsQuantityPackSelector(state, {
    skuId: productConfiguration.skuId
  }));
  const popQuantityPackPrice = useAppSelector(state => {
    return skuIdIsQuantityPack ? planBuilderMonthlyDiscountedPriceForQuantityPackSelector(state, {
      productConfiguration
    }) : undefined;
  });
  const price = popQuantityPackPrice || popPrice;
  return price;
};
export const useShoppingCartSkuInfo = ({
  productConfiguration
}) => {
  const skuId = productConfiguration.skuId;
  const skuIdIsHub = useAppSelector(state => skuIdIsHubSelector(state, {
    skuId
  }));
  const skuIdHasBundle = useAppSelector(state => skuIdHasBundledProductsSelector(state, {
    skuId
  }));
  const skuIdIsQuantityPack = useAppSelector(state => skuIdIsQuantityPackSelector(state, {
    skuId
  }));
  const isQuantifiableHubSkuAtProOrEnt = useAppSelector(state => isQuantifiableSeatProOrEntSkuSelector(state, {
    skuId
  }));
  const shouldShowQuantityInTitle = !skuIdIsHub && !skuIdHasBundle || isQuantifiableHubSkuAtProOrEnt;
  return {
    skuIdIsQuantityPack,
    shouldShowQuantityInTitle,
    isQuantifiableHubSkuAtProOrEnt
  };
};
export const useShoppingCartProductConfigInfo = ({
  skuId,
  isAppAuth,
  country
}) => {
  const allProductConfigurations = useAppSelector(planBuilderProductConfigurationsSelector);
  const productConfiguration = allProductConfigurations.find(({
    skuId: searchSkuId
  }) => skuId === searchSkuId);
  const skuIdIsHub = useAppSelector(state => skuIdIsHubSelector(state, {
    skuId
  }));

  // Gets the quantity packs (e.g. Marketing Contacts) included with a hub product
  const quantityPackProductConfigurations = useAppSelector(state => {
    const sku = skuSelector(state, {
      skuId
    });

    // If the whole line item is just for one quantity pack or addon
    if (!skuIdIsHub) {
      return [];
    }
    if (!('quantityPackDetails' in sku)) return [];
    const {
      quantityPackDetails
    } = sku;
    return quantityPackDetails.map(({
      skuId: quantityPackSkuId,
      includedWithProductVersion
    }) => {
      if (isCoreSeatSkuSelector(state, {
        skuId: quantityPackSkuId
      })) {
        Raven.captureMessage('Attempting to show core seat sku as quantityPack', {
          extra: {
            skuId,
            quantityPackSkuId,
            isAppAuth,
            isUngatedForSeats: true,
            country,
            currentUrl: window.location.href
          }
        });
      }
      return createProductConfig({
        skuId: quantityPackSkuId,
        quantity: includedWithProductVersion
      });
    });
  });
  return {
    productConfiguration,
    quantityPackProductConfigurations
  };
};